// extracted by mini-css-extract-plugin
module.exports = {"containerForm":"form_containerForm__1U7g9","form":"form_form__3N3wk","areaSelect":"form_areaSelect__2iCFo","areaButtons":"form_areaButtons__3-EBr","ritch":"form_ritch__2sj8Z"};